import Icon from "@mui/material/Icon";
import SignIn from "layouts/pages/authentication/sign-in";
import ManageFeed from "pages/Admin/manageFeeds";
import ContactUs from "pages/LandingPages/ContactUs";
import SharePage from "pages/LandingPages/Share";

// Sections
import FindAlumini from "pages/LandingPages/FindAlumini";
import GatePass from "pages/LandingPages/Gatepass";
import UpdatePersonalDetails from "pages/LandingPages/UpdatePersonalDetails";

const routes = [
  {
    name: "Important Links",
    icon: <Icon>dashboard</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Important Links",
        collapse: [
          {
            name: "Find Alumini",
            route: "/pages/alumini",
            component: <FindAlumini />,
          },
          {
            name: "Generate Gatepass",
            route: "/pages/gatepass",
            component: <GatePass />,
          },
          {
            name: "Request for Guest house",
            route: "/pages/gatepass",
            component:<GatePass />,
          },
          {
            name: "Contact Us",
            route: "/pages/Contact-us",
            component: <ContactUs />,
          },
          {
            name: "My Profile ",
            route: "/pages/myProfile",
            component:<UpdatePersonalDetails />,
          },
        ],
      },
      {
        name: "account",
        collapse: [
          {
            name: "sign in",
            route: "/pages/authentication/sign-in",
            component: <SignIn />,
          },
        ],
      },
    ],
  },
  {
    name: "OBA and More",
    icon: <Icon>dashboard</Icon>,
    collapse: [
      {
        name: "OBA Constitution",
        description: "See OBA related information",
        dropdown: true,
        collapse: [
          {
            name: "Bye Laws",
            route: "/",
          },
          {
            name: "Organisation",
            route: "/",
          },
        ],
      },
      {
        name: "Office Bearers",
        description: "View all office bearers",
        dropdown: false,
      },
      {
        name: "Members",
        description: "Search for all members",
      },
    ],
  },
  {
    name: "Share",
    route: "/share/:id",
    component: <SharePage />,
  },
];

export default routes;

export const adminRoutes = [
  {
    name: "Important Links",
    icon: <Icon>dashboard</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Important Links",
        collapse: [
          {
            name: "Manage Feed",
            route: "/admin/feeds",
            component: <ManageFeed />,
          },
          {
            name: "Check gate passess ",
            route: "/pages/gatepass",
            component:<GatePass />,
          },

          {
            name: "Contact Us",
            route: "/pages/Contact-us",
            component: <ContactUs />,
          },
        ],
      },
    ],
  },
];